<template>
  <div>
    <div class="container-fluid">
      <div class="row banner align-items-center">
        <div class="col-md-6 col-12">
          <div class="personal_info">
            <div class="d-flex">
              <img style="max-width:200px; min-width:150px;" :src="schoolInfo.logo" />
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 group_info">
          <div class="d-sm-flex align-items-center">
            <div class="info-box">
              <div class="title">
                {{ copy.group }}
              </div>
              <select v-model="selected">
                <option value="0" disabled selected>{{ copy.selectGroup }}</option>
                <option v-for="(item, index) in groupList" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div>
              <div class="info-box ">
                <div class="title">
                  <!-- <img style="height:30px" src="../assets/image/pic/icon_class_time.png" alt=""> -->
                  {{ copy.studentCount }}
                </div>
                <div class="content">
                  {{groupInfo.student_count?groupInfo.student_count:0}}
                </div>
              </div>
            </div>
            <div>
              <div class="info-box">
                <div class="title">
                  <!-- <img style="height:30px" src="../assets/image/pic/icon_class_time.png" alt=""> -->
                  {{ copy.coursePeriod }}
                </div>
                <div class="content">
                    {{moment(personalData.group_begin_at).format('YYYY/MM/DD')}} - {{ moment(personalData.group_end_at).format('YYYY/MM/DD')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="d-flex menu">
            <div @click="goPage('Summary')"  class="title d-sm-flex pointer" :class="{'active' : title === 'Summary' || $route.name === 'Info' || $route.name === 'Curve'}">
              <img style="height:30px" src="../assets/image/pic/icon_text.png" alt="">
              <div class="my-auto">
                {{ copy.learningReport }}
              </div>
            </div>
            <div @click="goPage('Room')"  class="title d-sm-flex pointer" :class="{'active' : $route.name === 'Room' || $route.name === 'Score'}">
              <img style="height:30px" src="../assets/image/pic/icon_company.png" alt="">
              <div class="my-auto">
                {{ copy.examRoom }}
              </div>
            </div>
            <div @click="goPage('Exam-Summary')"  class="title d-sm-flex pointer" :class="{ active: $route.name && $route.name.includes('Exam-') }">
              <img style="height:30px" src="../assets/image/pic/icon_toeictalk.png" alt="">
              <div class="my-auto">
                {{ copy.examResults }}
              </div>
            </div>
            <div @click="goPage('AI-Record')"  class="title d-sm-flex pointer" :class="{ active: $route.name && $route.name.includes('AI') }">
              <img style="height:30px" class="mb-1" src="../assets/image/pic/icon_AI.png" alt="">
              <div class="my-auto">
                {{ copy.aiAssistant }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <router-view :inputGroup="groupList" :personalData="personalData"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import { mapActions, mapState } from 'vuex'
import api from '../store/api'
export default {
  name: 'Teacher',
  data () {
    return {
      personalData: {},
      groupList: [],
      selected: this.$route.params.groupId,
      groupInfo: {},
      schoolInfo: {},
      title: this.$route.name
    }
  },
  computed: {
    ...mapState(['auth']),
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          group: '班別',
          selectGroup: '請選擇班級',
          studentCount: '班級人數',
          coursePeriod: '課程期間',
          learningReport: '學習報表',
          examRoom: '考場功能',
          examResults: '檢測成績',
          aiAssistant: 'AI小助教',
          testAccountAlert: '測試帳號不提供此功能'
        },
        en: {
          group: 'Class',
          selectGroup: 'Select a class',
          studentCount: 'Students',
          coursePeriod: 'Course Period',
          learningReport: 'Learning Reports',
          examRoom: 'Exam Room',
          examResults: 'Test Results',
          aiAssistant: 'AI Assistant',
          testAccountAlert: 'This feature is not available for test accounts.'
        }
      }

      return copy[this.currentLocale] || copy.tw
    },
    segment () {
      return this.moment(this.personalData.group_begin_at).format('YYYY-MM-DD') + ' ~ ' + this.moment(this.personalData.group_end_at).format('YYYY-MM-DD')
    },
    groupId () {
      return this.$route.params.groupId
    }
  },
  watch: {
    selected(val) {
      this.$router.push({ params: { groupId: val}})
    },
    'auth.personalData' (data) {
      if (data) {
        this.personalData = data
        this.getGroupList(data.enterprise_id)
        this.getSchoolInfo(data.enterprise_id)
      }
    }
  },
  mounted() {
    this.scrollTop()
    this.getPersonalData()
    this.getGroupInfo()
    // this.getUser()
  },
  methods: {
    ...mapActions({
      getUser: 'getUser'
    }),
    goPage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    },
    async getPersonalData () {
      if (this.auth.personalData) {
        this.personalData = this.auth.personalData
        this.getGroupList(this.auth.personalData.enterprise_id)
        this.getSchoolInfo(this.auth.personalData.enterprise_id)
      } else {
        await this.getUser()
      }
    },
    async getSchoolInfo(id) {
      const { data } = await api.get(`enterprises/${id}`)
      this.schoolInfo = data.data
    },
    async getGroupList(id) {
      const { data } = await api.get(`enterprises/${id}/groups?pageSize=100000`)
      this.groupList = data.data
    },
    async getGroupInfo() {
      const { data } = await api.get(`groups/${this.groupId}`)
      this.groupInfo = data.data
    },
    testAccount () {
      alert(this.copy.testAccountAlert)
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
  .banner {
    min-height: 250px;
    background-image: url('../assets/image/pic/bg_member_top.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .cefr {
      padding: 2px;
      font-size: 1rem;
      line-height: 1rem;
      background-color: rgb(255, 0, 0);
      border: 2px solid #fff;
      border-radius: 20%;
    }
    h2 {
      margin: 0;
    }
  }
  .main {
    background-color: #eee;
  }
  .main-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: red;
  }
  .circle_picture {
    width: 100px;
    height: 100px;
    border-radius:50%;
  }
  .personal_info {
    text-align: left;
    color: #fff;
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .active {
    color: red;
    font-weight: bolder;
  }
  .info-box {
    margin: 10px;
    .title {
      padding: 3px;
      min-width: 150px;
      background-color: #fff;
      font-weight: bold;
      color: #51A8DD;
    }
    select {
      width: 100%;
      padding: 10px;
      border: none;
      border-top: 1px solid #ccc;
    }
    .content {
      white-space:nowrap;
      padding: 10px;
      color: #fff;
      border: 1px #fff solid;
    }
  }
  .menu {
    .title {
      margin: 20px;
      font-weight: bolder;
    }
  }
  @media(max-width: 1080px){
    .banner {
      height: 55vh;
    }
    .personal_info {
      margin-top: 8vh;
    }
    .group_info {
      margin-top: 8vh;
      .info-box {
        margin: 20px;
      }
    }
  }
</style>
